module.exports = __webpack_public_path__ + "static/media/liveImage.581721b6.jpg";